import Phaser from 'phaser';
import { Player } from './Player';

export class HealthPickup extends Phaser.Physics.Arcade.Sprite {
  private player: Player;
  private healAmount: number;
  private magnetRange: number = 80;

  constructor(scene: Phaser.Scene, x: number, y: number, player: Player, healAmount: number = 20) {
    super(scene, x, y, '');

    this.player = player;
    this.healAmount = healAmount;

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.createHealthTexture(scene);
    this.setTexture('pickup-health');

    // Disable animations for performance
  }

  private createHealthTexture(scene: Phaser.Scene): void {
    const graphics = scene.add.graphics();
    const size = 20;
    const halfSize = size / 2;

    // Outer glow
    graphics.fillStyle(0xFF6B6B, 0.3);
    graphics.fillCircle(halfSize, halfSize, 9);

    // Heart shape
    graphics.fillStyle(0xFF0000, 1);

    // Left half of heart
    graphics.fillCircle(halfSize - 3, halfSize - 2, 4);
    // Right half of heart
    graphics.fillCircle(halfSize + 3, halfSize - 2, 4);
    // Bottom triangle
    graphics.fillTriangle(
      halfSize - 7, halfSize,
      halfSize + 7, halfSize,
      halfSize, halfSize + 7
    );

    // Heart highlight
    graphics.fillStyle(0xFF6B6B, 1);
    graphics.fillCircle(halfSize - 2, halfSize - 3, 2);
    graphics.fillCircle(halfSize + 2, halfSize - 3, 2);

    // White shine
    graphics.fillStyle(0xFFFFFF, 0.6);
    graphics.fillCircle(halfSize - 3, halfSize - 4, 1.5);

    graphics.generateTexture('pickup-health', size, size);
    graphics.destroy();
  }

  public setMagnetRange(range: number): void {
    this.magnetRange = range;
  }

  update(): void {
    if (!this.active || !this.player || !this.player.active) return;

    const distance = Phaser.Math.Distance.Between(
      this.x,
      this.y,
      this.player.x,
      this.player.y
    );

    // Magnetic pull
    if (distance < this.magnetRange) {
      const direction = new Phaser.Math.Vector2(
        this.player.x - this.x,
        this.player.y - this.y
      );

      direction.normalize();
      direction.scale(300);
      this.setVelocity(direction.x, direction.y);
    } else {
      this.setVelocity(0, 0);
    }

    // Collect if close enough
    if (distance < 20) {
      this.collect();
    }
  }

  private collect(): void {
    // Heal player
    const healed = Math.min(this.healAmount, this.player.maxHealth - this.player.health);
    this.player.health += healed;

    // Emit event for sound
    this.scene.events.emit('health-collected');

    // Floating text
    const healText = this.scene.add.text(this.x, this.y, `+${healed}`, {
      fontSize: '16px',
      color: '#00FF00',
      fontStyle: 'bold'
    });
    healText.setOrigin(0.5);

    this.scene.tweens.add({
      targets: healText,
      y: healText.y - 40,
      alpha: 0,
      duration: 1000,
      onComplete: () => {
        healText.destroy();
      }
    });

    this.destroy();
  }
}
